import React from 'react';

import "./css/orderSummary.css";
import { useAuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useCartContext } from '../context/CartContext';
import { deletetFromCart } from '../apiCalls/products';


const OrderSummary = ({ show, onHide, dehliveryAddress, totalProducts, totalPrice }) => {
    const {name,address,city,state,pincode,contact}=dehliveryAddress;
    const {isLogin}=useAuthContext();
    const {cart,resetCart}=useCartContext();
    const navigate=useNavigate();


    const cartReset=async()=>{
      
      cart.map(async(cartProduct)=>{
        const res=await deletetFromCart(cartProduct.product._id);
      })
      resetCart();


    }

    const loadScript = async (url) => {
      return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = url;
  
        script.onload = () => {
          resolve(true);
        };
  
        script.onerror = () => {
          resolve(false);
        };
  
        document.body.appendChild(script);
      });
    };
  
    const displayRazorpay = async () => {
      const res = await loadScript(
        "https://checkout.razorpay.com/v1/checkout.js"
      );
  
      if (!res) {
        console.error(
          "Razorpay SDK failed to load, check you connection",
          "error"
        );
        return;
      }
  
      const options = {
        key: "rzp_test_SjsVW8L8KUYm6P",
        amount: (totalPrice+3) * 100 ,
        currency:"USD",
        name: "ShoeCraft",
        handler: async function () {
          setTimeout(() => {
            navigate("/");
          }, 2000);
          await cartReset();
          navigate('/orderConfirmation');
          
        },
        prefill: {
          name: isLogin ? localStorage.getItem('userName') : "Test",
          email: isLogin ? localStorage.getItem('email') : "abc@gmail.com",
        },
        theme: {
          color: "#ac2986",
        },
      };
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    };
  
    const clickHandler = () => {
      displayRazorpay();
      setTimeout(() => {
        onHide();
      }, 1500);
    };



  return (
    <>
      {show && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={onHide}>&times;</span>
            <h3>Order Summary</h3>
            <div className="addressCard">
              <h5>Dehlivering To:</h5>
              <p>{name}</p>
              <p>{address}</p>
              <p>{city}{"  "} {pincode}</p>
              <p>{state}</p>
              <p>{contact}</p>
            </div>
            <p>Total Products: {totalProducts}</p>
            <p>Sub Total: {totalPrice}</p>
            <p>Delivery Charges: ${3}</p>
            <p className='bold-paragraph'>Total Price: ${totalPrice + 3}</p>
            <button className='paymentBtn' onClick={clickHandler}>Proceed to payment</button>
          </div>
    
        </div>
      )}
    </>
  );
};

export default OrderSummary;
